import { render, staticRenderFns } from "./ren-process-start.vue?vue&type=template&id=1724d972"
import script from "./ren-process-start.vue?vue&type=script&lang=js"
export * from "./ren-process-start.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports